import {httpClient2, httpClient} from '@/api';

export const _getMarkHistory = ({apiKey, username, dateRange}) => {
  return httpClient2.post(`batch/user/getHistory`,
    {
      system_id: 1,
      username,
      start_mark_date_range: dateRange
    }, {
      headers: {
        'api-key': apiKey
      }
    }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _registerNewUser = ({ apiKey, username, password, user_group, info }) => {
  return httpClient2.post(`batch/user/new`,
    {
      username,
      password,
      user_group,
      info: []
    }, {
      headers: {
        'api-key': apiKey
      }
    }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(true);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
// warn:超级账户权限
export const _deleteUser = ({ apiKey, username, root_password }) => {
  return httpClient2.post(`batch/user/delete`,
    {
      username,
      root_password
    }, {
      headers: {
        'api-key': apiKey
      }
    }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(true);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
// warn: 超级账户权限
export const _getAllUserList = (apiKey) => {
  return httpClient2.post(`batch/user/list`,
    {}, {
      headers: {
        'api-key': apiKey
      }
    }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
// export const _getRecordDetail = ({ apiKey }) => {
//   return httpClient2.post(`batch/user/info`,
//     {}, {
//       headers: {
//         'api-key': apiKey
//       }
//     }).then(res => {
//     if (res.data.state_code === 0) {
//       return Promise.resolve(res.data.data);
//     } else {
//       return Promise.reject(new Error(`${res.data.error_msg}`));
//     }
//   }).catch(handleError);
// };
// warn: 修改
export const _editUser = ({ apiKey, username, password, user_group, info }) => {
  return httpClient2.post(`batch/user/edit`,
    {
      username,
      password,
      user_group,
      info: []
    }, {
      headers: {
        'api-key': apiKey
      }
    }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(true);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
// 用户权限更改
export const _editPermissions = ({ username, permission }) => {
  return httpClient.post(`user_permit/add`,
    { username, permission }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
// 获取用户的权限
export const _getUserPermissions = ({username}) => {
  console.log(username);
  return httpClient.post(`user_permit/query`,
    { username }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else if (res.data.state_code === -1) {
      return Promise.reject(new Error("无用户的权限信息, 请添加"));
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
